import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, MailX, Loader2 } from "lucide-react";
import Logo from "../../components/site/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Baja() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/unsubscribe`, { email });
      setDone(true);
      toast.success("Te has dado de baja correctamente.");
    } catch (err) {
      toast.error("No se pudo procesar la baja. Inténtalo de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/">
            <Logo />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-bold text-espana-red hover:text-espana-reddark transition-colors"
          >
            <ArrowLeft size={16} /> Volver al inicio
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-5 py-16">
        <div className="w-full max-w-md bg-white border border-gray-200 rounded-sm p-8">
          <div className="h-12 w-12 flex items-center justify-center bg-espana-red/10 text-espana-red mb-5">
            <MailX size={26} />
          </div>
          <h1 className="text-2xl font-black tracking-tight">Baja del boletín</h1>
          {done ? (
            <p className="mt-4 text-gray-600" data-testid="baja-done">
              Tu correo ha sido eliminado de nuestra lista. Ya no recibirás más
              novedades. Puedes volver a suscribirte cuando quieras.
            </p>
          ) : (
            <>
              <p className="mt-3 text-gray-600">
                Introduce el correo con el que te suscribiste para dejar de recibir
                nuestras novedades.
              </p>
              <form onSubmit={submit} data-testid="baja-form" className="mt-6 space-y-4">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="baja-email"
                  placeholder="tu@correo.es"
                  className="w-full border border-gray-300 rounded-sm px-4 py-3 focus:outline-none focus:ring-1 focus:ring-espana-red focus:border-espana-red transition-colors"
                />
                <button
                  type="submit"
                  disabled={loading}
                  data-testid="baja-submit"
                  className="w-full inline-flex items-center justify-center gap-2 bg-espana-red hover:bg-espana-reddark disabled:opacity-60 text-white font-bold px-6 py-3 rounded-sm transition-colors"
                >
                  {loading ? <Loader2 size={18} className="animate-spin" /> : <MailX size={18} />}
                  Darme de baja
                </button>
              </form>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
